import BatchCreateModal from "./BatchCreateModal"
import useCustomTemplateInputs from "./BatchCreateForm/helpers/useCustomTemplateInputs"

export default BatchCreateModal

export {
  useCustomTemplateInputs
}
